import { render, staticRenderFns } from "./TrainingVideo.vue?vue&type=template&id=4c05adc0&scoped=true"
import script from "./TrainingVideo.vue?vue&type=script&lang=ts"
export * from "./TrainingVideo.vue?vue&type=script&lang=ts"
import style0 from "./TrainingVideo.vue?vue&type=style&index=0&id=4c05adc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05adc0",
  null
  
)

export default component.exports